/**
 * This script contains helper functions to iteract with Service Desk loading component.
 */

class LoadingHelper {
  static navbar: HTMLSySdNavbarElement;
  static loading = false;
  static triggerCount = 0;
}

export function initLoading(navbar: HTMLSySdNavbarElement): void {
  LoadingHelper.navbar = navbar;
}

export function setLoading(state: boolean): boolean {
  if (state) {
    LoadingHelper.triggerCount++;
  } else if (LoadingHelper.triggerCount > 0) {
    LoadingHelper.triggerCount--;
  }

  if (state !== LoadingHelper.loading && (state || LoadingHelper.triggerCount === 0)) {
    if (!LoadingHelper.navbar) return false;

    if (state) {
      LoadingHelper.navbar.setLoading(state);
      LoadingHelper.loading = state;
    } else {
      window.setTimeout(async () => {
        if (LoadingHelper.loading !== (await LoadingHelper.navbar.getLoading())) {
          LoadingHelper.navbar.setLoading(state);
        }
      }, 1000);
      LoadingHelper.loading = state;
    }
  }

  return true;
}
